import React from "react";
const OurPortfolioTab = ({ portfoilo }) => {
  return (
    <>
      <section>
        <div className="allPortfolio DBlock">
          <div className="max-w-7xl w-full">
              <div className="flex flex-col items-center sm:block">
                <img
                  src={`${portfoilo?.image}`}
                  alt="portfolioImg"
                  className="w-full h-auto"
                />
              </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default OurPortfolioTab;
